/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrCellRange } from './igr-cell-range';
import { CellRange } from './CellRange';
import { TypeRegistrar } from "igniteui-react-core";
var IgrCellRangeModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrCellRangeModule() {
    }
    IgrCellRangeModule.register = function () {
        TypeRegistrar.registerCons("IgrCellRange", IgrCellRange);
        TypeRegistrar.register("CellRange", CellRange.$type);
    };
    return IgrCellRangeModule;
}());
export { IgrCellRangeModule };
//# sourceMappingURL=igr-cell-range-module.js.map
